module.exports = __webpack_public_path__ + "media/images/soar/Plameet3-white-daaf384b3a97d483df32273b324eb4b1.png";